import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import '../App.css';
import './Contact.css'
const Contact = () => {
  
  return (
    <div className='container'>
      <div
        className='jumbotron jumbotron-fluid'
        style={{
          backgroundColor: 'whitesmoke',
          border: '1px gray solid',
          marginTop: '3rem',
          padding: '3rem',
        }}
      >
        <div className='container'>
        <center>
            <h1>2021 Contact List</h1>
          </center>
          <Link to='/'>
            {' '}
            <button className='btn btn-block btn-dark btn-sm p-3'>
              {' '}
              Back to Homepage
            </button>
          </Link>
 
          <div className='row'>
            <div className='col-md-6'>
              <h2 className='bolder'>
                Joanie Pimentel 
<br/>                <a href='mailto:jpimentel@oakwoodschool.org'>
                  jpimentel@oakwoodschool.org
                </a>
              </h2>
            </div>
            <div className='col-md-6'>
              <h5 className='card-title'>Director, Oakwood Summer Programs</h5>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-6'>
              <h2 className='bolder'>
                Denise Woodward 
                <br/><a href='mailto:dwoodward@oakwoodschool.org'>
                  dwoodward@oakwoodschool.org
                </a>
              </h2>
            </div>
            <div className='col-md-6'>
              <h5 className='card-title'>
                Immersive Experiences (grades 7-12)
              </h5>
              <h5>Academic Bootcamps (grades 7-12)</h5>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-6'>
              <h2 className='bolder'>
                Steve Smith 
                <br/><a href='mailto:ssmith@oakwoodschool.org'>
                ssmith@oakwoodschool.org
                </a>
              </h2>
            </div>
            <div className='col-md-6'>
              <h5 className='card-title'>
              Sports Camps
              </h5>
              
            </div>
          </div>

          <div className='row'>
            <div className='col-md-6'>
              <h2 className='bolder'>
              Lisa Pimentel 
                <br/><a href='mailto:lpimentel@oakwoodschool.org'>
                lpimentel@oakwoodschool.org
                </a>
              </h2>
            </div>
            <div className='col-md-6'>
              <h5 className='card-title'>
              Exploratorium (grades 4-12)
              </h5>
              <h5>Internship Program (grades 9+)</h5>
            </div>
          </div>


          <div className='row'>
            <div className='col-md-6'>
              <h2 className='bolder'>
              Carly Purmort 
                <br/><a href='mailto:cpurmort@oakwoodschool.org'>
                cpurmort@oakwoodschool.org
                </a>
              </h2>
            </div>
            <div className='col-md-6'>
              <h5 className='card-title'>
              Junior Exploratorium (grades 1-3)
              </h5>
              <h5>Kinder Kamp</h5>
            </div>
          </div>


          <div className='row'>
            <div className='col-md-6'>
              <h2 className='bolder'>
              Shane Finch 
                <br/><a href='mailto:sfinch@oakwoodschool.org'>
                sfinch@oakwoodschool.org
                </a>
              </h2>
            </div>
            <div className='col-md-6'>
              <h5 className='card-title'>
              Elementary Coding/STEAM</h5>
            </div>
          </div>



          
          <div className='row'>
            <div className='col-md-6'>
              <h2 className='bolder'>
              Marlene Huitink 
                <br/><a href='mailto:mhuitink@oakwoodschool.org'>
                mhuitink@oakwoodschool.org
                </a>
              </h2>
            </div>
            <div className='col-md-6'>
              <h5 className='card-title'>
              Virtual just-for-fun courses</h5>
            </div>
          </div>



          <Link to='/'>
            {' '}
            <button className='btn btn-block btn-dark btn-sm p-3'>
              {' '}
              Back to Homepage
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contact;
